'use strict';

const { Swiper } = require('swiper/bundle');

module.exports = Swiper;
